import { useState } from 'react';
import { useTranslate } from 'react-polyglot';

import type { ReactionType } from '@genially/p2p-lib';

import { REACTION_IMAGE } from '../../../../../../../../../../../../shared/application/utils/reactions';
import { ReactionAnimatedImage, StyledReactionButton } from './ReactionButton.styled';

const COOLDOWN_MS = 700;

interface ReactionButtonProps {
  type: ReactionType;
  emoji: string;
  onClick: (reactionType: ReactionType) => void;
}

export const ReactionButton = ({ type, emoji, onClick }: ReactionButtonProps) => {
  const t = useTranslate();
  const [cooldown, setCooldown] = useState(false);
  const [hovered, setHovered] = useState(false);

  const handleClick = () => {
    if (cooldown) return;

    onClick(type);

    setCooldown(true);
    setTimeout(() => setCooldown(false), COOLDOWN_MS);
  };

  const handleMouseEnter = () => setHovered(true);
  const handleMouseLeave = () => setHovered(false);

  return (
    <StyledReactionButton
      $cooldown={cooldown}
      onClick={handleClick}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      aria-label={t('play.reaction.send')}
      disabled={cooldown}
    >
      {hovered ? <ReactionAnimatedImage src={REACTION_IMAGE[type]} alt={emoji} /> : emoji}
    </StyledReactionButton>
  );
};
